import { render } from "./ChangePhoneModal.vue?vue&type=template&id=63e3a317"
import script from "./ChangePhoneModal.vue?vue&type=script&lang=js"
export * from "./ChangePhoneModal.vue?vue&type=script&lang=js"

import "./ChangePhoneModal.vue?vue&type=style&index=0&id=63e3a317&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__